import React from 'react';
import { Box, Container, Typography, Stack } from '@mui/material';

const Terms = () => {
    return (
        <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', py: 10 }}>
            <Container maxWidth="md">
                <Typography variant="h3" sx={{ fontWeight: 900, mb: 6 }}>Terms of Service</Typography>
                <Stack spacing={4} sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>1. Acceptance of Terms</Typography>
                        <Typography variant="body1">
                            By accessing and using this platform, you agree to comply with and be bound by these Terms of Service.
                            Our services are intended for professional social media automation and lead management.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>2. Automation Policy</Typography>
                        <Typography variant="body1">
                            Users are responsible for ensuring that their use of automation features complies with the respective
                            policies of social media platforms (Meta, X, YouTube, LinkedIn, Reddit). We are not responsible for
                            account suspensions resulting from misuse.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>3. AI Content Governance</Typography>
                        <Typography variant="body1">
                            While our AI provides safety filters, users are ultimately responsible for the content posted
                            through AI-generated suggestions or automated replies.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>4. Limitation of Liability</Typography>
                        <Typography variant="body1">
                            The service is provided "as is". We shall not be liable for any indirect, incidental, or
                            consequential damages arising out of the use of our automation tools.
                        </Typography>
                    </Box>
                </Stack>
            </Container>
        </Box>
    );
};

export default Terms;
